__turbopack_context__.v({
  "active": "eYx1IW_active",
  "disabled": "eYx1IW_disabled",
  "item": "eYx1IW_item",
  "segmentControl": "eYx1IW_segmentControl",
});
